import { WOW } from "wowjs";

(function ($) {
    $(document).ready(function () {
        const wow = new WOW();
        let body = $("body");

        wow.init();

        //keyboard navigation
        if (window.innerWidth > 991) {
            $(".wp-menu").superfish();
        }

        /**
         * Team Block - update volunteer read more link
         */
        let teamBlock = $('#team-member-block_456a259d13d2e8616b865939d5817335');

        $.each($('.row', teamBlock), function (i, v){
            if ($('.team-member', v).attr('data-first-name') === 'Adult Day Program Volunteer') {
                let linkText = $('.card-content-expand-btn', $(this));
                linkText.text('Learn more about our Adult Day Program Locations');
            }
        });

        /**
         * Change Forgot Password link
         */
        $(".login-form form a").attr(
            "href",
            "/client-login/?action=lostpassword"
        );

        /**
         * Login form - Add placeholders
         */
        $(".login-form input[type=text]").attr("placeholder", "Username");
        $(".login-form input[type=password]").attr("placeholder", "Password");

        /**
         * Mobile Menu - Append translator
         */
        let translator = $("#google_translate_element");
        let mobileMenu = $(".mobile-menu");

        if (window.innerWidth < 992) {
            mobileMenu.append(translator);
        }

        $(".menu-item-has-children")
            .find(".dropdown-toggle")
            .attr("data-toggle", "");

        /**
         * Font Size Change Functionality
         */
        $("#font-size-increase").click(function () {
            changeFontSize(1);
        });

        $("#font-size-decrease").click(function () {
            changeFontSize(-1);
        });

        function changeFontSize(direction) {
            let effectedElements = $(
                ".content-page p:not([class]), .content-container p:not([class]), p.card-excerpt, p.post-excerpt, .post-grid-block .col.sidebar-col .card .card-title, .post-grid-block .card .card-text, #search-page-filter-tab-content .card-text p"
            );

            effectedElements.each(function () {
                let $this = $(this);
                $this.data("orig-size", $this.css("font-size"));
            });

            effectedElements.each(function () {
                let $this = $(this);
                let currentFontSize = parseInt(
                    $this
                        .css("font-size")
                        .substring(0, $this.css("font-size").length - 2)
                );

                if (
                    (direction === 1 && currentFontSize < 36) ||
                    (direction === -1 && currentFontSize > 18)
                ) {
                    $this.css(
                        "font-size",
                        parseInt($(this).css("font-size")) + direction
                    );
                }
            });
        }

        /**
         * Back to top button - scroll functionality
         */
        $("#back-to-top").on("click", function () {
            $("html, body").animate(
                {
                    scrollTop: 0,
                },
                400
            );

            return false;
        });

        /**
         * Copyright - Display current year
         */
        let copyrightYear = new Date().getFullYear();
        $("#copyright-year").text(copyrightYear);

        /**
         * Add class to body when sticky header is showing
         */
        if ($(window).scrollTop() > 100) {
            body.addClass("sticky-header");
        } else {
            body.removeClass("sticky-header");
        }
        $(window).scroll(function () {
            if ($(window).scrollTop() > 100) {
                $("body").addClass("sticky-header");
            } else {
                $("body").removeClass("sticky-header");
            }
        });

        //normalize the height of alerts
        function alertCarouselNormalization() {
            var items = $("#alert-system .carousel-item"), //grab all slides
                heights = [], //create empty array to store height values
                tallest; //create variable to make note of the tallest slide

            if (items.length) {
                normalizeHeights(items, heights, tallest);

                $(window).on("resize orientationchange", function () {
                    (tallest = 0), (heights.length = 0); //reset vars
                    items.each(function () {
                        $(this).css("min-height", "0"); //reset min-height
                    });
                    normalizeHeights(items, heights, tallest); //run it again
                });
            }
        }

        alertCarouselNormalization();

        function normalizeHeights(items, heights, tallest) {
            items.each(function () {
                //add heights to array
                heights.push($(this).height());
                console.log("height " + $(this).height());
            });
            tallest = Math.max.apply(null, heights); //cache largest value
            items.each(function () {
                $(this).css("min-height", tallest + "px");
                $(this)
                    .find(".wrapper")
                    .css("min-height", tallest + "px");
            });
        }

        let adminbarHeight = 0;
        //alert height
        let alertSection = $("#alert-system");
        let alertHeight = 0;

        function setTheHeights(alertIsVisible = true) {
            if ($(body).hasClass("admin-bar")) {
                adminbarHeight = $("#wpadminbar").height();
            }

            //if the alert section is showing update the height
            if (
                $("#alert-system").length > 0 &&
                $("#alert-system").css("display") !== "none" &&
                alertIsVisible
            ) {
                alertHeight = $("#alert-system").height();
                console.log("this is" + alertHeight);
            } else {
                alertHeight = 0;
                console.log("not this is" + alertHeight);
            }

            //set the top attribute of the header
            $("header").css("top", adminbarHeight + alertHeight);

            /**
             * Main Content - Add padding to accommodate fixed header
             */
            let headerHeight = $("header").height();
            $("#content").css("padding-top", headerHeight + alertHeight);
        }
        setTheHeights();

        $(document).scroll(function () {
            let scrollAmount = $(window).scrollTop();
            if (alertSection.get(0) && scrollAmount < alertHeight) {
                $("header").css(
                    "top",
                    adminbarHeight + alertHeight - scrollAmount
                );
            } else {
                $("header").css("top", adminbarHeight);
            }
        });

        $("#alert-system .close").click(function () {
            setTheHeights(false);
            console.log("processed");
        });

        /**
         * Header - Search bar functionality
         */
        let searchButton = $(".search-button");
        let closeButton = $("#close-button");
        let searchBar = $("#search-container");

        // Change placeholder
        searchBar
            .find("form input")
            .attr("placeholder", "What are you looking for?");

        // Search click
        $.each(searchButton, function () {
            $(this).on("click", function () {
                searchBar.fadeIn().addClass("show");
            });
        });

        // Close click
        closeButton.on("click", function () {
            searchBar.fadeOut().removeClass("show");
        });

        /**
         * Social slider
         */
        $.each(
            $(".social-slider-block .social-slider"),
            function (index, slider) {
                var sliderID = "#" + $(slider).attr("id");
                /*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
                $(this).on("slide.bs.carousel", function (e) {
                    var $e = $(e.relatedTarget);
                    var idx = $e.index();
                    var itemsPerSlide = 7;
                    var totalItems = $(sliderID + " .carousel-item").length;

                    if (idx >= totalItems - (itemsPerSlide - 1)) {
                        var it = itemsPerSlide - (totalItems - idx);
                        for (var i = 0; i < it; i++) {
                            // append slides to end
                            if (e.direction === "left") {
                                $(sliderID + " .carousel-item")
                                    .eq(i)
                                    .appendTo(sliderID + " .carousel-inner");
                            } else {
                                $(sliderID + " .carousel-item")
                                    .eq(0)
                                    .appendTo(sliderID + " .carousel-inner");
                            }
                        }
                    }
                });
            }
        );

        /**
         * Social Slider - Link functionality
         */
        $.each(
            $(
                ".social-slider-block .carousel .carousel-inner .carousel-item .social-item"
            ),
            function () {
                let postLink = $(this).attr("data-link");

                $(this).on("click", function () {
                    window.open(postLink, "_blank").focus();
                });
            }
        );

        /**
         * Carousel - Set equal heights
         */
        function carouselEqualHeights() {
            $(".carousel-block").each(function () {
                var items = $(".carousel-item", this);
                let maxHeight = 0;

                // Show all slides
                $.each(items, function (i, slide) {
                    $(slide).addClass("active");
                });

                // Get the height of the tallest caption and save it
                // Desktop
                if (window.innerWidth >= 993) {
                    $.each(items, function () {
                        let caption = $(".carousel-caption", this);
                        let captionHeight = caption.outerHeight();

                        if (captionHeight > maxHeight) {
                            maxHeight = captionHeight;
                        }
                    });

                    // Apply the max height to all captions
                    $.each(items, function () {
                        let caption = $(this);
                        caption.css("height", maxHeight + 200);

                        // Remove .active from all slides
                        $(this).removeClass("active");
                    });

                    // Mobile
                } else {
                    $.each(items, function () {
                        let caption = $(this);
                        let captionHeight = caption
                            .css("height", "auto")
                            .outerHeight();

                        if (captionHeight > maxHeight) {
                            maxHeight = captionHeight;
                        }
                    });

                    // Apply the max height to all captions
                    $.each(items, function () {
                        let caption = $(this);
                        caption.css("height", maxHeight);

                        // Remove .active from all slides
                        $(this).removeClass("active");
                    });
                }

                // Add the active class back to the first slide
                $(
                    ".carousel-block .carousel-inner .carousel-item:first-of-type"
                ).addClass("active");
            });
        }

        // Run equal heights
        carouselEqualHeights();

        /**
         * Testimonial - Set equal heights
         */
        function testimonialEqualHeights() {
            $(".testimonial-large-block, .testimonial-block").each(function () {
                var items = $(".carousel-item", this);
                let maxHeight = 0;

                // Show all slides
                $.each(items, function (i, slide) {
                    $(slide).addClass("active");
                });

                // Get the height of the tallest caption and save it
                $.each(items, function () {
                    let caption = $(".card-body", this);
                    let captionHeight = caption.outerHeight();

                    if (captionHeight > maxHeight) {
                        maxHeight = captionHeight;
                    }
                });

                // Apply the max height to all captions
                $.each(items, function () {
                    let caption = $(".card-body", this);
                    caption.css("height", maxHeight);

                    // Remove .active from all slides
                    $(this).removeClass("active");
                });

                // Add the active class back to the first slide
                $(
                    ".testimonial-large-block .carousel-inner .carousel-item:first-of-type, .testimonial-block .carousel-inner .carousel-item:first-of-type"
                ).addClass("active");
            });
        }

        // Run equal heights
        testimonialEqualHeights();

        /**
         * Mobile menu - Open/close functionality
         */
        var mobileMenuButton = $(".mobile-menu-button");
        var mobileMenuWrap = $(".mobile-menu-wrap ");
        var mobileCloseButton = $(".mobile-menu-close ");
        let mobileMenuBackBtn = $(".mobile-menu-back-btn");

        mobileMenuWrap
            .find(".mobile-menu > .menu-item-has-children > .sub-menu")
            .addClass("fade");

        mobileMenuButton.on("click", function () {
            $("body").toggleClass("no-scroll mobile-menu-open");

            mobileMenuWrap
                .find(".mobile-menu .sub-menu.show")
                .removeClass("show")
                .hide();

            mobileMenuWrap
                .find(".mobile-menu > .menu-item > .nav-link")
                .css("visibility", "");

            mobileMenuBackBtn.removeClass("show");

            mobileMenuWrap.fadeToggle(400, function () {
                if ($(this).is(":hidden")) {
                    $(".mobile-menu .sub-menu.show", this).removeClass("show");

                    mobileMenuBackBtn.css("display", "").removeClass("show");

                    mobileMenuWrap
                        .find(
                            ".mobile-menu > .menu-item-has-children > .sub-menu"
                        )
                        .css("display", "")
                        .removeClass("show");
                }
            });

            return false;
        });

        mobileCloseButton.on("click", function () {
            mobileMenuWrap.fadeOut();

            $("body").toggleClass("no-scroll");

            return false;
        });

        /**
         * Mobile menu - Spacer
         */
        let secondaryItems = $("ul.mobile-menu li.menu-item.secondary");

        $.each($(secondaryItems), function (i, v) {
            if (i === 0) {
                $(v).addClass("first-secondary-item");
            }
        });

        /**
         * Mobile menu - sub menu functionality
         */

        // Top level items in dropdown that have a sub menu
        mobileMenuWrap
            .find(".mobile-menu > .menu-item-has-children > .nav-link")
            .on("click", function (evt) {
                evt.preventDefault();

                // Show back button
                mobileMenuBackBtn
                    // Add ".show" class first to apply the correct CSS display value
                    .addClass("show")
                    // Then hide again so that it can be faded in
                    .hide()
                    .fadeIn(300);

                $(this)
                    .siblings(".sub-menu")
                    .css("height", $(this).siblings(".sub-menu").outerHeight())
                    .show(0, function () {
                        let parentItem = $(this)
                            .parent()
                            .find(">a.nav-link")
                            .text();

                        // Add parent title to sub menu
                        if (!$(this).find("li.parent-item").length === true) {
                            $(this).prepend(
                                '<li class="parent-item">' +
                                    parentItem +
                                    "</li>"
                            );
                        }

                        // Ensure the top of the menu is displayed
                        $(".mobile-menu")
                            .animate(
                                {
                                    scrollTop: 0,
                                },
                                1
                            )
                            .addClass("sub-menu-open");
                        $(this).addClass("show");
                    });

                setTimeout(function () {
                    mobileMenuWrap
                        .find(".mobile-menu > .menu-item > .nav-link")
                        .css("visibility", "hidden");
                }, 400);
            });

        mobileMenuBackBtn.on("click", function () {
            $(".mobile-menu").removeClass("sub-menu-open");

            $(this).fadeOut(300, function () {
                $(this).removeClass("show");
            });

            mobileMenuWrap
                .find(".mobile-menu .sub-menu.show")
                .css("height", "")
                .removeClass("show");

            setTimeout(function () {
                mobileMenuWrap.find(".mobile-menu .sub-menu").hide();
            }, 400);

            mobileMenuWrap
                .find(".mobile-menu > .menu-item > .nav-link")
                .css("visibility", "");

            setTimeout(function () {
                mobileMenuWrap
                    .find(".mobile-menu > .menu-item > .nav-link")
                    .fadeTo(300, 1);
            }, 10);
        });
    });
})(jQuery);
